import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button, Typography, Empty, Tabs } from "antd";
import btnStyles from "../../../styles/Custom/Button.module.css";
import { PlusOutlined } from "@ant-design/icons";
import MedicationTable from "./MedicationTable";
import MedicationForm from "./MedicationForm";
import { useNavigate } from "react-router-dom";
import useQuery from "../../../hooks/useQuery";
import {
  updateUrlSearchParams,
  parsePageParam,
  parseSearchParam,
} from "../../../helpers/urlFilters";
import { getMedicationApi } from "../../../services/medication.services";
import CustomLayout from "../../Layout/CustomLayout";
import typoStyles from "../../../styles/Custom/Typography.module.css";
import SideMenu from "../../Layout/CustomLayout/SideMenu";
import GlobalMedicationTable from "./GlobalMedicationTable";
import { UserContext } from "../../../context/UserContext";
import { getCookie } from "../../../helpers/localStorage";
import { Role } from "../../../constants/defaultKeys";
import { UiDataTable } from "../../ui";

const options = [
  { label: "Medicine List From Curengo", key: "medicine_list" },
  { label: "In-house Medicines", key: "additional_medicines" },
];
const Medication = () => {
  const { userDetails } = useContext(UserContext);
  const navigate = useNavigate();
  const params = useQuery();
  const [isVisible, setIsVisible] = useState(false);
  const [medicineData, setMedicineData] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(() => parsePageParam(params));
  const [searchQuery, setSearchQuery] = useState(() => parseSearchParam(params));

  const defaultRole = userDetails?.currRole || getCookie(Role);

  const refreshPage = () => {
    setRefresh((prev) => !prev);
  };

  useEffect(() => {
    let queryParams = { page: page, limit: 100 };
    if (searchQuery) {
      queryParams.search = searchQuery;
      queryParams.page = 1;
    }
    const queryString = new URLSearchParams(queryParams);
    setLoading(true);
    getMedicationApi(queryString)
      .then((res) => {
        setMedicineData(res?.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, [refresh, page, searchQuery]);

  const onChange = (value) => {
    setPage(1);
    setSearchQuery(null);
    updateUrlSearchParams(navigate, {
      medicine: value,
      search: null,
      page: null,
    });
  };

  const onMedSearch = (value) => {
    const query = value?.target?.value;
    setSearchQuery(query || null);
    setPage(1);
    updateUrlSearchParams(navigate, { search: query || null, page: null });
  };

  const handlePageChange = (value) => {
    setPage(value);
    updateUrlSearchParams(navigate, { page: value === 1 ? null : value });
  };
  return (
    <CustomLayout
      header={
        <div
          style={{
            gap: "5%",
            width: "100%",
          }}
          className="flex-start"
        >
          <Typography className={typoStyles.h6}>Medicines</Typography>
          <Tabs
            items={options}
            onChange={onChange}
            defaultActiveKey={params?.medicine}
            style={{ width: "80%", paddingTop: "16px" }}
          />
        </div>
      }
      sideContent={<SideMenu />}
    >
      {params?.medicine === "additional_medicines" ? (
        <>
          {medicineData?.data?.length < 0 ? (
            <Row className="facilities">
              {defaultRole === "Facility_Admin" ? (
                <Empty />
              ) : (
                <Col span={24} style={{ textAlign: "center" }}>
                  <Button
                    type="primary"
                    onClick={() => setIsVisible(true)}
                    className={btnStyles.lgBtn}
                  >
                    <PlusOutlined /> Medicines
                  </Button>
                </Col>
              )}
            </Row>
          ) : (
            <UiDataTable
              showHeader={false}
              shellClassName="ui-table-fill-shell"
              onSearch={onMedSearch}
              searchPlaceholder="Search medicines"
              toolbarTrailing={
                defaultRole !== "Facility_Admin" ? (
                  <Button
                    type="primary"
                    onClick={() => setIsVisible(true)}
                    className={btnStyles.lgBtn}
                  >
                    <PlusOutlined /> Medicines
                  </Button>
                ) : null
              }
            >
              <MedicationTable
                data={medicineData}
                setData={setMedicineData}
                refreshPage={refreshPage}
                loading={loading}
                page={page}
                setPage={handlePageChange}
                userDetails={userDetails}
              />
            </UiDataTable>
          )}
        </>
      ) : (
        <GlobalMedicationTable />
      )}

      {isVisible && (
        <MedicationForm
          open={isVisible}
          setOpen={setIsVisible}
          refreshPage={refreshPage}
        />
      )}
    </CustomLayout>
  );
};

export default Medication;
